/**
 * @generated SignedSource<<dfe1abb499c1b239d167ea7454397832>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CalendarOverviewEventItemDateTime_event$data = {
  readonly endAtDateAndTime: {
    readonly isoString: string;
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly endAtTime: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly endAtWeekdayAndDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly isAllDayEvent: boolean;
  readonly startAtDateAndTime: {
    readonly isoString: string;
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly startAtWeekdayAndDate: {
    readonly " $fragmentSpreads": FragmentRefs<"StoreFormattedDate">;
  };
  readonly " $fragmentType": "CalendarOverviewEventItemDateTime_event";
};
export type CalendarOverviewEventItemDateTime_event$key = {
  readonly " $data"?: CalendarOverviewEventItemDateTime_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarOverviewEventItemDateTime_event">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isoString",
    "storageKey": null
  },
  {
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "DEFAULT"
      }
    ],
    "kind": "FragmentSpread",
    "name": "StoreFormattedDate"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "style",
        "value": "WEEKDAY_AND_DATE"
      }
    ],
    "kind": "FragmentSpread",
    "name": "StoreFormattedDate"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CalendarOverviewEventItemDateTime_event",
  "selections": [
    {
      "alias": "startAtDateAndTime",
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "startAt",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": "endAtDateAndTime",
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "endAt",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": "startAtWeekdayAndDate",
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "startAt",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "endAtWeekdayAndDate",
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "endAt",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": "endAtTime",
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "endAt",
      "plural": false,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "style",
              "value": "TIME_ONLY"
            }
          ],
          "kind": "FragmentSpread",
          "name": "StoreFormattedDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAllDayEvent",
      "storageKey": null
    }
  ],
  "type": "CalendarEvent",
  "abstractKey": null
};
})();

(node as any).hash = "dffc0daa9f4be00c7ada275d7fa7a522";

export default node;
